/**
 * Browser copy of core_libs/helpers/config_helper/pick-config-to-schema-shape.js
 */

function pickConfigToSchemaShape(schemaItems, data = {}, options = {}) {
    const fillDefaults = options.fillDefaults !== false;
    const result = {};
    if (!schemaItems || typeof schemaItems !== "object") return result;

    const src = data && typeof data === "object" && !Array.isArray(data) ? data : {};

    for (const key of Object.keys(schemaItems)) {
        const schemaField = schemaItems[key];
        const type = schemaField.type;
        const value = src[key];

        if (type === "multi-input") {
            const itemSchema = schemaField.type_items?.[0] || schemaField.items;
            if (Array.isArray(value)) {
                result[key] = value.map((item) =>
                    pickConfigToSchemaShape(itemSchema, item || {}, options)
                );
            } else if (fillDefaults) {
                result[key] = Array.isArray(schemaField.default) ? [...schemaField.default] : [];
            }
            continue;
        }

        if (type === "multi-input-object") {
            const itemSchema = schemaField.type_items || schemaField.items || {};
            const out = {};
            const saved = value && typeof value === "object" && !Array.isArray(value) ? value : {};
            for (const objKey of Object.keys(saved)) {
                out[objKey] = pickConfigToSchemaShape(itemSchema, saved[objKey] || {}, options);
            }
            result[key] = out;
            continue;
        }

        if (schemaField.items && typeof schemaField.items === "object" && !Array.isArray(schemaField.items)) {
            result[key] = pickConfigToSchemaShape(schemaField.items, value || {}, options);
            continue;
        }

        if (value !== undefined) {
            result[key] = value;
        } else if (fillDefaults && schemaField.default !== undefined) {
            result[key] = schemaField.default;
        } else if (fillDefaults && type === "boolean") {
            result[key] = false;
        } else if (fillDefaults) {
            result[key] = "";
        }
    }

    return result;
}

export { pickConfigToSchemaShape };
